import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationService } from '../services/navigation.service';

@Injectable()
export class NavBackGuard implements CanDeactivate<any> {

  constructor(private navigationService: NavigationService) { }

  canDeactivate(_component: any,
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return !this.navigationService.isGoingBack();
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/guards/nav-back.guard.ts